import { useState } from 'react';
import { Box } from '@mui/material';
import { Button, Input } from '@sm-dashboard/ui-components';

// Too little text for the AI to extract anything meaningful from.
const MIN_TEXT_LENGTH = 20;

interface AiFreeTextInputProps {
  busy: boolean;
  onSubmit: (text: string) => void;
}

/** Multiline input for pasting the event announcement text, submitted to the AI extraction. */
export const AiFreeTextInput = ({ busy, onSubmit }: AiFreeTextInputProps) => {
  const [text, setText] = useState('');

  return (
    <Box sx={{ mt: 1.5, display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Input
        multiline
        minRows={4}
        maxRows={10}
        value={text}
        onChange={event => setText(event.target.value)}
        placeholder="הדביקו כאן את נוסח ההודעה או המודעה על האירוע"
        disabled={busy}
      />
      <Box sx={{ alignSelf: 'flex-start' }}>
        <Button
          variant="outlined"
          color="primary"
          fullWidth={false}
          disabled={busy || text.trim().length < MIN_TEXT_LENGTH}
          onClick={() => onSubmit(text.trim())}
        >
          חילוץ הפרטים
        </Button>
      </Box>
    </Box>
  );
};
